import { Component } from 'react'
import _ from 'lodash'
import clx from 'classnames'
import moment from 'moment'
import { Button, Tip } from '@vzmi/shp_shared_compo'
import { DEFAULT_DASHBOARD_DATE_RANGE, YESTERDAY } from '../../../../../constants/date'
import { getIsInRange } from '../../../../../lib/MomentHelper'
import {
  RangePickerField,
  RadioGroupInputField,
  InputField
} from '../../../../Common/Form'
import { showOnlyNumber } from '../../../../../lib/formatter'
import FormRow from '../../../../Common/NewDashboard/FormRow/FormRow'
import {
  formDecorator,
  Field,
  FormValueSelector
} from '../../../../Common/forms'
import {
  LISTING_TYPE,
  LISTING_TYPE_OPTIONS
} from '../../constants/listing'
import styles from './SearchForm.css'

export const FIELD = {
  REPORT_DATE: 'reportDate',
  LISTING_TYPE: 'listingType',
  LISTING_IDS: 'listingIds'
}

export const validateListingId = (values) => {
  const listingType = values[FIELD.LISTING_TYPE]
  const listingId = values[FIELD.LISTING_IDS]

  if (listingType !== LISTING_TYPE.ORDER) {
    return {}
  }

  if (listingId === '') {
    return { [FIELD.LISTING_IDS]: '請輸入賣場編號' }
  }

  return {}
}

const syncValidator = values => {
  let errors = {}
  errors = _.merge(errors, validateListingId(values))
  return errors
}

const SIX_MONTH_BEFORE = moment().subtract(6, 'months')

export const INIT_VALUES = {
  [FIELD.REPORT_DATE]: DEFAULT_DASHBOARD_DATE_RANGE,
  [FIELD.LISTING_TYPE]: LISTING_TYPE.ALL,
  [FIELD.LISTING_IDS]: ''
}

export const CONFIG = {
  form: 'RETURNS_ANALYSIS_DASHBOARD_FORM',
  validate: syncValidator,
  initialValues: INIT_VALUES
}

class SearchForm extends Component {
  componentDidMount () {
    this.props.onFormInit(this.props)
  }

  onSubmit = (e) => {
    this.props.handleSubmit(e)
  }

  disabledDate = current => {
    return !getIsInRange(current, [SIX_MONTH_BEFORE, YESTERDAY])
  }

  render () {
    const { onListingTypeChange } = this.props
    return (
      <form
        onSubmit={this.onSubmit}
        className={styles.searchForm}
      >
        <FormRow
          label='日期區間'
          labelAlign='center'
        >
          <Field
            key={FIELD.REPORT_DATE}
            name={FIELD.REPORT_DATE}
            data-role={FIELD.REPORT_DATE}
            className={styles.rangePicker}
            component={RangePickerField}
            disabledDate={this.disabledDate}
            allowClear={false}
          />
        </FormRow>
        <FormRow
          labelAlign='top'
          className={styles.tips}
        >
          <Tip type='info'>
            查詢區間最長為六個月, 每日中午更新
          </Tip>
        </FormRow>
        <FormRow
          label='賣場'
          labelAlign='top'
        >
          <Field
            key={FIELD.LISTING_TYPE}
            name={FIELD.LISTING_TYPE}
            data-role={FIELD.LISTING_TYPE}
            className={styles.listingType}
            component={RadioGroupInputField}
            buttonStyle='outline'
            options={LISTING_TYPE_OPTIONS}
            onChange={onListingTypeChange}
          />
        </FormRow>
        <FormValueSelector fieldName={FIELD.LISTING_TYPE}>
          {listingType => {
            const isFieldVisible = listingType === LISTING_TYPE.ORDER
            return (
              <FormRow
                style={{ marginTop: 15 }}
                className={clx(
                  styles.listingIdRow,
                  { hidden: !isFieldVisible }
                )}
              >
                <Field
                  key={FIELD.LISTING_IDS}
                  name={FIELD.LISTING_IDS}
                  data-role={FIELD.LISTING_IDS}
                  className={styles.listingIds}
                  component={InputField}
                  placeholder='輸入賣場編號'
                  parse={showOnlyNumber}
                />
              </FormRow>
            )
          }}
        </FormValueSelector>
        <FormRow labelAlign='top'>
          <Button
            type='submit'
            data-role='search-btn'
            size='large'
            className={styles.searchBtn}
          >
            查詢
          </Button>
        </FormRow>
      </form>
    )
  }
}

const SearchFormWithDecorator = formDecorator(CONFIG)(SearchForm)

export default SearchFormWithDecorator
